export default __webpack_public_path__ + "media/devops_essentials_bundle_header.125588dc3995d47326b3d9ea1d789cb6.svg";